import {createRouter, createWebHistory} from 'vue-router'

import store from '@/store'

// 基础路由
export const baseRouter = [
    {
        path: '/',
        redirect: '/login',
        component: () => import('@/views/login')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login')
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/404'),
        meta: {
            title: '404'
        }
    }
]

// 权限路由
export const allRouter = [
    {
        path: '/index',
        redirect: '/index/index',
        component: '@/views/layout/base-layout',
        meta: {
            title: '首页',
            icon: 'icon-menu-index'
        },
        children: [
            {
                path: '/index',
                component: '@/views/index',
            },
        ]
    },
    {
        path: '/information-inquiry',
        component: '@/views/layout/base-layout',
        hidden: true, // 隐藏导航栏菜单（路由保留，页面仍可通过 URL 访问）
        meta: {
            title: '信息查询',
            icon: 'icon-menu-informationInquiry'
        },
        children: [
            {
                path: '/information-inquiry/user-details-inquiry',
                component: '@/views/information-inquiry/user-details-inquiry',
                meta: {
                    title: '用户信息查询',
                    icon: 'icon-menu-informationInquiry-userDetailsInquiry'
                }
            }
        ]
    },
    {
        path: '/business-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '业务管理',
            icon: 'icon-menu-businessManage'
        },
        children: [
            {
                path: '/business-manage/business-processing',
                component: '@/views/business-manage/business-processing',
                meta: {
                    title: '业务办理',
                    icon: 'icon-menu-businessManage-businessProcessing'
                }
            }
        ]
    },
    {
        path: '/charge-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '收费管理',
            icon: 'icon-menu-chargeManage'
        },
        children: [
            {
                path: '/charge-manage/counter-charge',
                component: '@/views/charge-manage/counter-charge',
                meta: {
                    title: '柜台收费',
                    icon: 'icon-menu-chargeManage-counterCharge'
                }
            },
            {
                path: '/charge-manage/bank-deduction',
                component: '@/views/charge-manage/bank-deduction',
                meta: {
                    title: '银行代扣',
                    icon: 'icon-menu-chargeManage-bankDeduction'
                }
            },
            {
                path: '/charge-manage/reverse-invoice',
                component: '@/views/charge-manage/reverse-invoice',
                meta: {
                    title: '发票冲红',
                    icon: 'icon-menu-chargeManage-reverseInvoice'
                }
            },
            {
                path: '/charge-manage/cancel-charge',
                component: '@/views/charge-manage/cancel-charge',
                meta: {
                    title: '取消收费',
                    icon: 'icon-menu-chargeManage-cancelCharge'
                }
            }
        ]
    },
    {
        path: '/calculation-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '计费管理',
            icon: 'icon-menu-calculationManage'
        },
        children: [
            {
                path: '/calculation-manage/generate-bill-manage',
                meta: {
                    title: '成单管理',
                    icon: 'icon-menu-calculationManage-generateBillManage'
                },
                children: [
                    {
                        path: '/calculation-manage/generate-bill-manage/generate-bill',
                        component: '@/views/calculation-manage/generate-bill-manage/generate-bill',
                        meta: {
                            title: '生成账单',
                            icon: 'icon-menu-calculationManage-generateBillManage-generateBill'
                        }
                    },
                ]
            },
            {
                path: '/calculation-manage/change-manage',
                meta: {
                    title: '变更管理',
                    icon: 'icon-menu-calculationManage-changeManage'
                },
                children: [
                    {
                        path: '/calculation-manage/change-manage/bill-change',
                        component: '@/views/calculation-manage/change-manage/bill-change',
                        meta: {
                            title: '账单变更',
                            icon: 'icon-menu-calculationManage-changeManage-billChange'
                        }
                    }
                ]
            },
            {
                path: '/calculation-manage/leakage-apportion',
                meta: {
                    title: '漏损分摊',
                    icon: 'icon-menu-calculationManage-leakageApportion'
                },
                children: [
                    {
                        path: '/calculation-manage/leakage-apportion/apportion-config',
                        component: '@/views/calculation-manage/leakage-apportion/apportion-config',
                        meta: {
                            title: '分摊配置',
                            icon: 'icon-menu-calculationManage-leakageApportion-apportionConfig'
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/sms-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '短信管理',
            icon: 'icon-menu-smsManage'
        },
        children: [
            {
                path: '/sms-manage/send-sms',
                component: '@/views/sms-manage/send-sms',
                meta: {
                    title: '发送短信',
                    icon: 'icon-menu-smsManage-sendSMS'
                }
            },
            {
                path: '/sms-manage/sms-record',
                component: '@/views/sms-manage/sms-record',
                meta: {
                    title: '短信记录',
                    icon: 'icon-menu-smsManage-smsRecord'
                }
            }
        ]
    },
    {
        path: '/online-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '线上管理',
            icon: 'icon-menu-onlineManage'
        },
        children: [
            {
                path: '/online-manage/business-approval',
                meta: {
                    title: '线上业务',
                    icon: 'icon-menu-onlineManage-businessApproval'
                },
                children: [
                    {
                        path: '/online-manage/business-approval/all-business',
                        component: '@/views/online-manage/business-approval/all-business',
                        meta: {
                            title: '所有业务',
                            icon: 'icon-menu-onlineManage-businessApproval-allBusiness'
                        }
                    },
                    {
                        path: '/online-manage/business-approval/approval-business',
                        component: '@/views/online-manage/business-approval/approval-business',
                        meta: {
                            title: '待审批业务',
                            icon: 'icon-menu-onlineManage-businessApproval-approvalBusiness'
                        }
                    },
                    {
                        path: '/online-manage/business-approval/review-business',
                        component: '@/views/online-manage/business-approval/review-business',
                        meta: {
                            title: '待复核业务',
                            icon: 'icon-menu-onlineManage-businessApproval-reviewBusiness'
                        }
                    },
                    {
                        path: '/online-manage/business-approval/business-info',
                        hidden: true,
                        children: [
                            {
                                path: '/online-manage/business-approval/business-info/transfer-apply',
                                component: '@/views/online-manage/business-approval/business-info/transfer-apply',
                                meta: {
                                    title: '过户申请业务信息'
                                }
                            },
                            {
                                path: '/online-manage/business-approval/business-info/combined-meter-declare',
                                component: '@/views/online-manage/business-approval/business-info/combined-meter-declare',
                                meta: {
                                    title: '合表水价申请业务信息'
                                }
                            },
                            {
                                path: '/online-manage/business-approval/business-info/step-population-declare',
                                component: '@/views/online-manage/business-approval/business-info/step-population-declare',
                                meta: {
                                    title: '阶梯人口申报业务信息'
                                }
                            },
                            {
                                path: '/online-manage/business-approval/business-info/bank-deduct',
                                component: '@/views/online-manage/business-approval/business-info/bank-deduct',
                                meta: {
                                    title: '银行代扣业务信息'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: '/online-manage/wechat-message',
                meta: {
                    title: '微信消息',
                    icon: 'icon-menu-onlineManage-wechatMessage'
                },
                children: [
                    {
                        path: '/online-manage/wechat-message/push-message',
                        component: '@/views/online-manage/wechat-message/push-message',
                        meta: {
                            title: '消息推送',
                            icon: 'icon-menu-onlineManage-wechatMessage-pushMessage'
                        }
                    },
                ]
            },
        ]
    },
    {
        path: '/meter-read-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '抄表管理',
            icon: 'icon-menu-meterReadManage'
        },
        children: [
            {
                path: '/meter-read-manage/centralize-meter-manage',
                meta: {
                    title: '集中抄表管理',
                    icon: 'icon-menu-meterReadManage-centralizeMeterReadManage'
                },
                children: [
                    {
                        path: '/meter-read-manage/centralize-meter-manage/status-monitor',
                        component: '@/views/meter-read-manage/centralize-meter-manage/status-monitor',
                        meta: {
                            title: '状态监控',
                            icon: 'icon-menu-meterReadManage-centralizeMeterReadManage-statusMonitor'
                        }
                    },
                    {
                        path: '/meter-read-manage/centralize-meter-manage/data-import',
                        component: '@/views/meter-read-manage/centralize-meter-manage/data-import',
                        meta: {
                            title: '数据入库',
                            icon: 'icon-menu-meterReadManage-centralizeMeterReadManage-dataImport'
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/report-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '上报管理',
            icon: 'icon-menu-reportManage'
        },
        children: [
            {
                path: '/report-manage/gdemp-report',
                meta: {
                    title: '广东能源管理服务平台上报管理',
                    icon: 'icon-menu-reportManage-gdempReport'
                },
                children: [
                    {
                        path: '/report-manage/gdemp-report/info-report',
                        component: '@/views/report-manage/gdemp-report/info-report',
                        meta: {
                            title: '信息上报',
                            icon: 'icon-menu-reportManage-gdempReport-infoReport'
                        },
                    }
                ]
            }
        ]
    },
    {
        path: '/statistical-report',
        component: '@/views/layout/base-layout',
        meta: {
            title: '统计报表',
            icon: 'icon-menu-statisticalReport'
        },
        children: [
            {
                path: '/statistical-report/charge-statistics',
                meta: {
                    title: '收费统计',
                    icon: 'icon-menu-statisticalReport-chargeStatistics'
                },
                children: [
                    {
                        path: '/statistical-report/charge-statistics/bank-deduction-report',
                        component: '@/views/statistical-report/charge-statistics/bank-deduction-report',
                        meta: {
                            title: '银行代扣报表',
                            icon: 'icon-menu-statisticalReport-chargeStatistics-bankDeductionReport'
                        }
                    },
                    {
                        path: '/statistical-report/charge-statistics/online-transaction-report',
                        component: '@/views/statistical-report/charge-statistics/online-transaction-report',
                        meta: {
                            title: '线上交易报表',
                            icon: 'icon-menu-statisticalReport-chargeStatistics-onlineTransactionReport'
                        }
                    }
                ]
            },
        ]
    },
    {
        path: '/system-manage',
        component: '@/views/layout/base-layout',
        meta: {
            title: '系统管理',
            icon: 'icon-menu-systemManage'
        },
        children: [
            {
                path: '/system-manage/print-setting',
                component: '@/views/system-manage/print-setting',
                meta: {
                    title: '打印设置',
                    icon: 'icon-menu-systemManage-printSetting'
                },
            }
        ]
    },
    {
        path: '/:pathMatch(.*)',
        redirect: '/404',
        hidden: true
    }
]

// 转换路由格式
const transformRouters = (router) => {
    return router.map(route => {
        const processedRoute = {...route};

        // 如果有组件路径，则动态导入
        if (route.component) {
            const componentPath = route.component.replace('@/', '');
            processedRoute.component = () => import(`@/${componentPath}`);
        }

        // 特殊处理基础布局组件
        if (route.component === '@/views/layout/base-layout') {
            processedRoute.component = () => import('@/views/layout/base-layout');
        }

        // 递归处理子路由
        if (route.children) {
            processedRoute.children = transformRouters(route.children);
        }

        return processedRoute;
    });
};

// 添加权限路由
export const addAccessedRouters = (role) => {

    const routers = transformRouters(allRouter);

    routers.forEach((item) => {
        router.addRoute(item);
    });

// 添加导航栏菜单
    store.commit("SET_NAVMENU_MENU", allRouter);
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: baseRouter
})

let firstLoad = true;

router.beforeEach((to, form, next) => {

    if (to.path === '/login') { // 登录页
        next();
        return;
    }

    const accountId = store.state.accountInfo.accountId;

    if (firstLoad) {

        if (accountId) {
            addAccessedRouters(); // 添加权限路由
            firstLoad = false;
            next({...to, replace: true}); // 重新加载页面
        } else {
            next('/login');
        }

    } else {
        next();
    }

// 添加标签页菜单
    var tabsMenu = store.state.tabsMenu.menu;
    var isExistTabsMenu = tabsMenu.findIndex(item => item.path === to.path);

    if (isExistTabsMenu === -1) { // 新打开页面添加标签页

        var json = {};
        json.title = to.meta.title;
        json.path = to.path;
        json.query = to.query;

        tabsMenu.push(json);

        store.commit("SET_TABSMENU_MENU", tabsMenu);

    } else { // 已打开页面更新参数

        tabsMenu[isExistTabsMenu].title = to.meta.title;
        tabsMenu[isExistTabsMenu].query = to.query;

    }

// 选中标签页
    var tabsMenuIndex = store.state.tabsMenu.menu.findIndex(item => item.path === to.path);

    store.commit("SET_TABSMENU_KEY", tabsMenuIndex);

// 添加缓存页面
    var cacheComponent = store.state.cacheComponent.name;
    var isExistCacheComponent = cacheComponent.findIndex(item => item === to.path);

    if (isExistCacheComponent === -1) { // 新打开页面添加至缓存组件

        cacheComponent.push(to.path);

        store.commit("SET_CACHECOMPONENT_NAME", cacheComponent);

    }
})

export default router
